import React, { Component } from 'react'
import axios from 'axios'
import moment from 'moment'
import { Row, Col, Skeleton, Modal, message } from 'antd'
import { connect } from 'react-redux'
import { ButtonItem } from '../../../../Components/Items'
import DatePickerItem from '../../../../Components/DatePickerItem'
import { ExclamationCircleOutlined } from '@ant-design/icons'

// ─── Helpers ──────────────────────────────────────────────────────────────────

const fmtMXN = (n) =>
  new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(n || 0)

const MESES = [
  'Enero','Febrero','Marzo','Abril','Mayo','Junio',
  'Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre',
]

const CALCULO_LABEL = {
  importe_fijo:    'Importe Fijo',
  proporcion_dias: 'Prop. Días Trabajados',
}

const CALCULO_AYUDA = {
  importe_fijo:    'Se descuenta el mismo monto en cada período',
  proporcion_dias: 'El descuento se prorratea por los días trabajados en el período',
}

const IMPORTE_PERIODO_LABEL = {
  importe_fijo:    'Importe fijo en el periodo',
  proporcion_dias: 'Importe mensual a prorratear',
}

// ─── Estilos tabla ────────────────────────────────────────────────────────────

const TH = {
  border: '1px solid #d0d0d0', background: '#f5f5f5',
  padding: '5px 8px', fontSize: 11, fontWeight: 600,
  color: '#555', textAlign: 'center', whiteSpace: 'nowrap',
}
const TD = {
  border: '1px solid #e8e8e8', padding: '4px 8px',
  fontSize: 12, verticalAlign: 'middle',
}
const TD_NUM = { ...TD, textAlign: 'right', fontFamily: 'monospace' }

// ─── Estilos formulario ───────────────────────────────────────────────────────

const labelStyle   = { display: 'block', fontSize: 11, color: '#888', marginBottom: 3 }
const inputStyle   = { width: '100%', padding: '4px 8px', border: '1px solid #d0d0d0', borderRadius: 4, fontSize: 12, boxSizing: 'border-box' }
const selectStyle  = { ...inputStyle, background: 'white', cursor: 'pointer', height: 28 }
const readonlyStyle = { ...inputStyle, background: '#f5f5f5', color: '#888' }
const rowStyle     = { display: 'flex', gap: 12, marginBottom: 10 }

// ─────────────────────────────────────────────────────────────────────────────

class FonacotEmpleado extends Component {

  state = {
    cargando:  false,
    error:     null,
    creditos:  [],
    empresa:   {},
    conceptos: [],
    // Formulario
    formVisible:          false,
    editandoId:           null,
    conceptoId:           '',
    numeroCreditoFonacot: '',
    descripcion:          '',
    observaciones:        '',
    mes:                  new Date().getMonth() + 1,
    ejercicio:            new Date().getFullYear(),
    calculoRetencion:     'importe_fijo',
    importeCredito:       '',
    importeFijoPeriodo:   '',
    fechaAplicacion:      '',
    pagosOtrosPatrones:   '',
    saldo:                '',
    guardando:            false,
    // Historial
    historialVisible:     false,
    historialCredito:     null,
  }

  verHistorial(credito) {
    this.setState({ historialVisible: true, historialCredito: credito })
  }

  cerrarHistorial() {
    this.setState({ historialVisible: false, historialCredito: null })
  }

  renderModalHistorial() {
    const { historialVisible, historialCredito } = this.state
    const bitacora = historialCredito?.bitacoraAplicaciones || []

    return (
      <Modal
        title={`Historial — ${historialCredito?.numeroCreditoFonacot || ''}`}
        visible={historialVisible}
        onCancel={() => this.cerrarHistorial()}
        footer={null}
        width={560}
      >
        <div style={{ overflowX: 'auto' }}>
          <table style={{ borderCollapse: 'collapse', width: '100%' }}>
            <thead>
              <tr>
                <th style={TH}>Fecha</th>
                <th style={{ ...TH, textAlign: 'right' }}>Importe Aplicado</th>
                <th style={{ ...TH, textAlign: 'right' }}>Acumulado</th>
                <th style={TH}>Liquidado</th>
              </tr>
            </thead>
            <tbody>
              {bitacora.length === 0 && (
                <tr>
                  <td colSpan={4} style={{ ...TD, textAlign: 'center', color: '#aaa', padding: 24 }}>
                    Sin movimientos registrados todavía
                  </td>
                </tr>
              )}
              {bitacora.map((mov, i) => (
                <tr key={i}>
                  <td style={TD}>{(mov.fecha + '').split('T')[0].split('-').reverse().join('/')}</td>
                  <td style={TD_NUM}>{fmtMXN(mov.importeAplicado)}</td>
                  <td style={TD_NUM}>{fmtMXN(mov.montoAcumuladoResultante)}</td>
                  <td style={{ ...TD, textAlign: 'center' }}>{mov.liquidado ? '✓' : ''}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Modal>
    )
  }

  componentDidMount() {
    this.cargarDatos()
    this.cargarConceptos()
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.empleadoId !== this.props.empleadoId ||
      prevProps.empresaId  !== this.props.empresaId
    ) {
      this.resetForm()
      this.cargarDatos()
    }
    if (prevProps.empresaId !== this.props.empresaId) {
      this.cargarConceptos()
    }
  }

  resetForm() {
    this.setState({
      formVisible: false, editandoId: null,
      conceptoId: '', numeroCreditoFonacot: '', descripcion: '',
      observaciones: '', mes: new Date().getMonth() + 1,
      ejercicio: new Date().getFullYear(), calculoRetencion: 'importe_fijo',
      importeCredito: '', importeFijoPeriodo: '', fechaAplicacion: '', pagosOtrosPatrones: '', saldo: '',
    })
  }

  // ── Fetch ──────────────────────────────────────────────────────────────────

  async cargarDatos() {
    const { empleadoId, empresaId, headersToken } = this.props
    if (!empleadoId || !empresaId) return
    this.setState({ cargando: true, error: null })
    try {
      const res = await axios.post(
        'nomina/creditosFonacot',
        { empleadoId, empresaId },
        { headers: headersToken }
      )
      if (res.data.success === 2) {
        this.setState({
          creditos: res.data.creditos || [],
          empresa:  res.data.empresa  || {},
        })
      } else {
        this.setState({ error: res.data.err || res.data.mensaje || 'Error al cargar créditos FONACOT' })
      }
    } catch {
      this.setState({ error: 'Error de conexión' })
    }
    this.setState({ cargando: false })
  }

  async cargarConceptos() {
    const { empresaId, headersToken } = this.props
    if (!empresaId) return
    try {
      const res = await axios.post(
        'conceptosNomina/selectAllConceptosNomina',
        { empresaId },
        { headers: headersToken }
      )
      if (res.data.success === 2) {
        this.setState({ conceptos: res.data.conceptosNomina || res.data.data || [] })
      }
    } catch { /* silent — el <select> quedará vacío */ }
  }

  autoSeleccionarConcepto() {
    const { conceptos } = this.state
    const auto = conceptos.find(c =>
      (c.descripcion || '').toLowerCase().includes('fonacot')
    )
    return auto ? auto._id : ''
  }

  // ── Acciones ───────────────────────────────────────────────────────────────

  confirmarInactivar(creditoId) {
    Modal.confirm({
      title: '¿Inactivar este crédito FONACOT?',
      content: 'Ya no se aplicará en futuros períodos.',
      icon: <ExclamationCircleOutlined />,
      okText: 'Sí, inactivar',
      cancelText: 'No',
      onOk: () => this.inactivarCredito(creditoId),
    })
  }

  async inactivarCredito(creditoId) {
    const { empresaId, headersToken } = this.props
    try {
      const res = await axios.post(
        'nomina/cancelarCreditoFonacot',
        { creditoId, empresaId },
        { headers: headersToken }
      )
      if (res.data.success === 2) {
        message.success('Crédito inactivado')
        this.cargarDatos()
        this.props.onCambio?.()
      } else {
        message.error(res.data.err || res.data.mensaje || 'Error al inactivar')
      }
    } catch {
      message.error('Error de conexión')
    }
  }

  abrirEdicion(credito) {
    this.setState({
      formVisible:          true,
      editandoId:           credito._id,
      conceptoId:           credito.conceptoId?._id || credito.conceptoId || '',
      numeroCreditoFonacot: credito.numeroCreditoFonacot || '',
      descripcion:          credito.descripcion || '',
      observaciones:        credito.observaciones || '',
      mes:                  credito.mes || new Date().getMonth() + 1,
      ejercicio:            credito.ejercicio || new Date().getFullYear(),
      calculoRetencion:     credito.calculoRetencion || 'importe_fijo',
      importeCredito:       credito.importeCredito !== undefined ? String(credito.importeCredito) : '',
      importeFijoPeriodo:   credito.importeFijoPeriodo !== undefined ? String(credito.importeFijoPeriodo) : '',
      fechaAplicacion:      credito.fechaAplicacion ? (credito.fechaAplicacion + '').split('T')[0] : '',
      pagosOtrosPatrones:   credito.pagosOtrosPatrones !== undefined ? String(credito.pagosOtrosPatrones) : '',
      saldo:                credito.saldo !== undefined ? String(credito.saldo) : '',
    })
  }

  abrirFormularioNuevo() {
    const conceptoId = this.autoSeleccionarConcepto()
    this.setState({
      formVisible: true, editandoId: null,
      conceptoId, numeroCreditoFonacot: '', descripcion: '',
      observaciones: '', mes: new Date().getMonth() + 1,
      ejercicio: new Date().getFullYear(), calculoRetencion: 'importe_fijo',
      importeCredito: '', importeFijoPeriodo: '', fechaAplicacion: '', pagosOtrosPatrones: '', saldo: '',
    })
  }

  async guardarCredito() {
    const { empleadoId, empresaId, headersToken } = this.props
    const {
      editandoId, conceptoId, numeroCreditoFonacot, descripcion,
      observaciones, mes, ejercicio, calculoRetencion,
      importeCredito, importeFijoPeriodo, fechaAplicacion, pagosOtrosPatrones, saldo,
    } = this.state

    if (!numeroCreditoFonacot.trim()) { message.error('Ingresa el número de crédito FONACOT'); return }
    const importeCreditoNum = parseFloat(importeCredito)
    if (importeCredito === '' || isNaN(importeCreditoNum)) { message.error('Ingresa el importe del crédito'); return }

    const body = {
      empleadoId, empresaId,
      conceptoId:           conceptoId || null,
      numeroCreditoFonacot: numeroCreditoFonacot.trim(),
      descripcion:          descripcion.trim(),
      observaciones:        observaciones.trim(),
      mes:                  parseInt(mes, 10),
      ejercicio:            parseInt(ejercicio, 10),
      calculoRetencion,
      importeCredito:       importeCreditoNum,
      importeFijoPeriodo:   parseFloat(importeFijoPeriodo) || 0,
      fechaAplicacion:      fechaAplicacion || null,
      pagosOtrosPatrones:   parseFloat(pagosOtrosPatrones) || 0,
      saldo:                parseFloat(saldo) || 0,
    }
    if (editandoId) body.creditoId = editandoId

    this.setState({ guardando: true })
    try {
      const url = editandoId ? 'nomina/editarCreditoFonacot' : 'nomina/crearCreditoFonacot'
      const res = await axios.post(url, body, { headers: headersToken })
      if (res.data.success === 2) {
        message.success(editandoId ? 'Crédito actualizado' : 'Crédito creado')
        this.resetForm()
        this.cargarDatos()
        this.props.onCambio?.()
      } else {
        message.error(res.data.err || res.data.mensaje || 'Error al guardar')
      }
    } catch {
      message.error('Error de conexión')
    }
    this.setState({ guardando: false })
  }

  // ── Render parciales ───────────────────────────────────────────────────────

  renderTabla() {
    const { creditos } = this.state
    const { timbrado } = this.props

    const btnStyle = (color) => ({
      fontSize: 11, padding: '2px 8px', borderRadius: 4,
      border: `1px solid ${color}`, cursor: 'pointer',
      background: 'white', color, marginRight: 4,
    })

    const colSpanBase = timbrado ? 11 : 12

    return (
      <div style={{ overflowX: 'auto', marginBottom: 12 }}>
        <table style={{ borderCollapse: 'collapse', width: '100%' }}>
          <thead>
            <tr>
              <th style={TH}>Concepto</th>
              <th style={TH}>Núm. Crédito</th>
              <th style={TH}>Descripción</th>
              <th style={TH}>Tipo Cálculo</th>
              <th style={{ ...TH, textAlign: 'right' }}>Importe Crédito</th>
              <th style={{ ...TH, textAlign: 'right' }}>Importe Periodo</th>
              <th style={TH}>Fecha Aplicación</th>
              <th style={{ ...TH, textAlign: 'right' }}>Monto Acum.</th>
              <th style={{ ...TH, textAlign: 'right' }}>Saldo</th>
              <th style={TH}>Mes/Año</th>
              <th style={TH}>Estatus</th>
              {!timbrado && <th style={TH}>Acciones</th>}
            </tr>
          </thead>
          <tbody>
            {creditos.length === 0 && (
              <tr>
                <td colSpan={colSpanBase} style={{ ...TD, textAlign: 'center', color: '#aaa', padding: 24 }}>
                  Sin créditos FONACOT registrados
                </td>
              </tr>
            )}
            {creditos.map(credito => {
              const inactivo = credito.estatus === 0
              const tdBase = inactivo
                ? { ...TD, color: '#999', textDecoration: 'line-through', background: '#f5f5f5' }
                : TD
              const tdNum = inactivo
                ? { ...TD_NUM, color: '#999', textDecoration: 'line-through', background: '#f5f5f5' }
                : TD_NUM
              const saldoActual = (credito.saldo || 0) - (credito.montoAcumulado || 0)
              const saldoColor = saldoActual <= 0 ? '#A32D2D' : undefined

              const conceptoLabel = credito.conceptoId
                ? (credito.conceptoId.codigo
                    ? credito.conceptoId.codigo + ' - ' + credito.conceptoId.descripcion
                    : credito.conceptoId.descripcion || '—')
                : '—'

              return (
                <tr key={credito._id}>
                  <td style={tdBase}>{conceptoLabel}</td>
                  <td style={tdBase}>{credito.numeroCreditoFonacot}</td>
                  <td style={tdBase}>{credito.descripcion || '—'}</td>
                  <td style={{ ...tdBase, textAlign: 'center' }}>
                    {CALCULO_LABEL[credito.calculoRetencion] || credito.calculoRetencion}
                  </td>
                  <td style={tdNum}>{fmtMXN(credito.importeCredito)}</td>
                  <td style={tdNum}>{fmtMXN(credito.importeFijoPeriodo)}</td>
                  <td style={{ ...tdBase, textAlign: 'center' }}>
                    {credito.fechaAplicacion ? (credito.fechaAplicacion + '').split('T')[0].split('-').reverse().join('/') : '—'}
                  </td>
                  <td style={tdNum}>{fmtMXN(credito.montoAcumulado)}</td>
                  <td style={{ ...tdNum, color: inactivo ? '#999' : saldoColor, fontWeight: saldoActual <= 0 ? 600 : undefined }}>
                    {fmtMXN(saldoActual)}
                  </td>
                  <td style={{ ...tdBase, textAlign: 'center' }}>
                    {credito.mes ? MESES[credito.mes - 1] : '—'} {credito.ejercicio || ''}
                  </td>
                  <td style={{ ...TD, textAlign: 'center' }}>
                    {inactivo
                      ? <span style={{ background: '#f0f0f0', color: '#888', padding: '2px 8px', borderRadius: 4, fontSize: 11 }}>Inactivo</span>
                      : <span style={{ background: '#f6ffed', color: '#52c41a', padding: '2px 8px', borderRadius: 4, fontSize: 11, border: '1px solid #b7eb8f' }}>Activo</span>
                    }
                  </td>
                  {!timbrado && (
                    <td style={{ ...TD, textAlign: 'center', whiteSpace: 'nowrap' }}>
                      <button type="button" style={btnStyle('#555')} onClick={() => this.verHistorial(credito)}>Historial</button>
                      {!inactivo && (
                        <>
                          <button type="button" style={btnStyle('#1677ff')} onClick={() => this.abrirEdicion(credito)}>Editar</button>
                          <button type="button" style={btnStyle('#A32D2D')} onClick={() => this.confirmarInactivar(credito._id)}>Inactivar</button>
                        </>
                      )}
                    </td>
                  )}
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    )
  }

  renderFormulario() {
    const {
      editandoId, conceptoId, numeroCreditoFonacot, descripcion,
      observaciones, mes, ejercicio, calculoRetencion,
      importeCredito, importeFijoPeriodo, fechaAplicacion, pagosOtrosPatrones,
      saldo, guardando, conceptos, creditos, empresa,
    } = this.state

    const creditoEditando = editandoId ? creditos.find(c => c._id === editandoId) : null
    const saldoActualEdit = creditoEditando
      ? (creditoEditando.saldo || 0) - (creditoEditando.montoAcumulado || 0)
      : null

    return (
      <div style={{ background: '#fafafa', border: '1px solid #e8e8e8', borderRadius: 6, padding: 16, marginTop: 12 }}>
        <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 12, color: '#333' }}>
          {editandoId ? 'Editar crédito FONACOT' : 'Nuevo crédito FONACOT'}
        </div>

        {/* a: Datos empresa (readonly) */}
        <div style={rowStyle}>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>Centro de trabajo FONACOT</label>
            <input style={readonlyStyle} value={empresa.centroTrabajoFonacot || '—'} readOnly />
          </div>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>Número FONACOT</label>
            <input style={readonlyStyle} value={empresa.numeroFonacot || '—'} readOnly />
          </div>
        </div>
        <div style={{ fontSize: 10, color: '#aaa', marginTop: -6, marginBottom: 10 }}>
          Datos de configuración de la empresa
        </div>

        {/* b: Concepto + Número crédito */}
        <div style={rowStyle}>
          <div style={{ flex: 2 }}>
            <label style={labelStyle}>Concepto</label>
            <select
              style={{ ...selectStyle, background: '#f5f5f5', color: '#555', cursor: 'not-allowed' }}
              value={conceptoId}
              disabled
            >
              <option value="">— Seleccionar —</option>
              {conceptos.map(c => (
                <option key={c._id} value={c._id}>
                  {c.codigo ? c.codigo + ' - ' + c.descripcion : c.descripcion}
                </option>
              ))}
            </select>
          </div>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>Número de crédito FONACOT *</label>
            <input
              style={inputStyle}
              value={numeroCreditoFonacot}
              onChange={e => this.setState({ numeroCreditoFonacot: e.target.value })}
              placeholder="Núm. asignado por FONACOT"
            />
          </div>
        </div>

        {/* c: Descripción + Observaciones */}
        <div style={rowStyle}>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>Descripción</label>
            <input
              style={inputStyle}
              value={descripcion}
              onChange={e => this.setState({ descripcion: e.target.value })}
              placeholder="Texto libre (opcional)"
            />
          </div>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>Observaciones</label>
            <input
              style={inputStyle}
              value={observaciones}
              onChange={e => this.setState({ observaciones: e.target.value })}
              placeholder="Texto libre (opcional)"
            />
          </div>
        </div>

        {/* d: Mes + Ejercicio + Cálculo */}
        <div style={rowStyle}>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>Mes</label>
            <select
              style={selectStyle}
              value={mes}
              onChange={e => this.setState({ mes: parseInt(e.target.value, 10) })}
            >
              {MESES.map((nombre, i) => (
                <option key={i + 1} value={i + 1}>{nombre}</option>
              ))}
            </select>
          </div>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>Ejercicio</label>
            <input
              type="number"
              style={inputStyle}
              value={ejercicio}
              onChange={e => this.setState({ ejercicio: e.target.value })}
              placeholder="Año"
            />
          </div>
          <div style={{ flex: 2 }}>
            <label style={labelStyle}>Cálculo de la retención</label>
            <select
              style={selectStyle}
              value={calculoRetencion}
              onChange={e => this.setState({ calculoRetencion: e.target.value })}
            >
              <option value="importe_fijo">Importe Fijo</option>
              <option value="proporcion_dias">Prop. Días Trabajados</option>
            </select>
            {calculoRetencion && (
              <div style={{ fontSize: 10, color: '#888', marginTop: 2 }}>
                {CALCULO_AYUDA[calculoRetencion]}
              </div>
            )}
          </div>
        </div>

        {/* e: Importes */}
        <div style={rowStyle}>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>Importe del crédito *</label>
            <input
              type="number"
              step="0.01"
              style={inputStyle}
              value={importeCredito}
              onChange={e => {
                const val = e.target.value
                const num = parseFloat(val) || 0
                const otros = parseFloat(pagosOtrosPatrones) || 0
                this.setState({ importeCredito: val, saldo: String(num - otros) })
              }}
              placeholder="0.00"
            />
          </div>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>{IMPORTE_PERIODO_LABEL[calculoRetencion] || 'Importe fijo en el periodo'}</label>
            <input
              type="number"
              step="0.01"
              style={inputStyle}
              value={importeFijoPeriodo}
              onChange={e => this.setState({ importeFijoPeriodo: e.target.value })}
              placeholder="0.00"
            />
          </div>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>Fecha de aplicación</label>
            <DatePickerItem
              style={{ ...inputStyle, width: '100%' }}
              value={fechaAplicacion ? moment(fechaAplicacion, 'YYYY-MM-DD') : null}
              onChange={(d) => this.setState({ fechaAplicacion: d ? d.format('YYYY-MM-DD') : '' })}
            />
          </div>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>Pagos hechos por otros patrones</label>
            <input
              type="number"
              step="0.01"
              style={inputStyle}
              value={pagosOtrosPatrones}
              onChange={e => {
                const val = e.target.value
                const num = parseFloat(val) || 0
                const credito = parseFloat(importeCredito) || 0
                this.setState({ pagosOtrosPatrones: val, saldo: String(credito - num) })
              }}
              placeholder="0.00"
            />
          </div>
        </div>

        {/* f: Saldo calculado/editable */}
        <div style={{ ...rowStyle, alignItems: 'flex-start' }}>
          <div style={{ flex: 1, maxWidth: 200 }}>
            <label style={labelStyle}>Saldo inicial</label>
            <input
              type="number"
              step="0.01"
              style={{ ...inputStyle, background: '#EDF5FF', border: '1px solid #91caff' }}
              value={saldo}
              onChange={e => this.setState({ saldo: e.target.value })}
              placeholder="0.00"
            />
            <div style={{ fontSize: 10, color: '#888', marginTop: 2 }}>
              Calculado automáticamente. Puedes ajustarlo si es necesario.
            </div>
          </div>
        </div>

        {/* g: Monto acumulado + Saldo actual (solo edición) */}
        {editandoId && creditoEditando && (
          <div style={rowStyle}>
            <div style={{ flex: 1 }}>
              <label style={labelStyle}>Monto acumulado retenido</label>
              <input style={readonlyStyle} value={fmtMXN(creditoEditando.montoAcumulado)} readOnly />
            </div>
            <div style={{ flex: 1 }}>
              <label style={labelStyle}>Saldo actual</label>
              <input
                style={{ ...readonlyStyle, color: saldoActualEdit <= 0 ? '#A32D2D' : '#888', fontWeight: saldoActualEdit <= 0 ? 600 : undefined }}
                value={fmtMXN(saldoActualEdit)}
                readOnly
              />
            </div>
            <div style={{ flex: 1 }} />
          </div>
        )}

        {/* h: Botones */}
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 4 }}>
          <button type="button"
            style={{ fontSize: 12, padding: '4px 14px', borderRadius: 4, border: '1px solid #d0d0d0', cursor: 'pointer', background: 'white' }}
            onClick={() => this.resetForm()}
            disabled={guardando}
          >
            Cancelar captura
          </button>
          <ButtonItem type="primary" size="small" loading={guardando} onClick={() => this.guardarCredito()}>
            Guardar
          </ButtonItem>
        </div>
      </div>
    )
  }

  render() {
    const { timbrado, readOnly } = this.props
    const { cargando, error, creditos, formVisible } = this.state

    const activos   = creditos.filter(c => c.estatus === 1).length
    const inactivos = creditos.filter(c => c.estatus === 0).length

    if (cargando && creditos.length === 0) {
      return <Skeleton active paragraph={{ rows: 4 }} />
    }

    return (
      <div>
        {timbrado && (
          <div style={{ marginBottom: 12, padding: '7px 14px', background: '#fffbe6', border: '1px solid #ffe58f', borderRadius: 6, fontSize: 12, color: '#7c5a00' }}>
            Nómina timbrada — visualización de solo lectura.
          </div>
        )}

        <Row gutter={12} style={{ marginBottom: 12 }}>
          <Col span={12}>
            <div style={{ background: '#f6ffed', border: '1px solid #b7eb8f', borderRadius: 6, padding: '10px 14px' }}>
              <div style={{ fontSize: 11, color: '#52c41a' }}>Créditos activos</div>
              <div style={{ fontSize: 22, fontWeight: 700, color: '#52c41a' }}>{activos}</div>
            </div>
          </Col>
          <Col span={12}>
            <div style={{ background: '#f5f5f5', border: '1px solid #d9d9d9', borderRadius: 6, padding: '10px 14px' }}>
              <div style={{ fontSize: 11, color: '#888' }}>Créditos inactivos</div>
              <div style={{ fontSize: 22, fontWeight: 700, color: '#888' }}>{inactivos}</div>
            </div>
          </Col>
        </Row>

        {!timbrado && !readOnly && !formVisible && (
          <div style={{ marginBottom: 8, textAlign: 'right' }}>
            <ButtonItem size="small" onClick={() => this.abrirFormularioNuevo()}>
              + Agregar crédito
            </ButtonItem>
          </div>
        )}

        {error && (
          <div style={{ color: '#A32D2D', background: '#fff1f0', padding: '8px 12px', borderRadius: 4, marginBottom: 8, fontSize: 12 }}>
            {error}
          </div>
        )}

        {this.renderTabla()}
        {formVisible && this.renderFormulario()}
        {this.renderModalHistorial()}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  headersToken: state.user.headersToken,
  empresaId:    state.empresa.id,
})

export default connect(mapStateToProps)(FonacotEmpleado)
